import { render } from "./DetailDemandePage.vue?vue&type=template&id=36dff995&ts=true"
import script from "./DetailDemandePage.vue?vue&type=script&lang=ts"
export * from "./DetailDemandePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__